import { graphqlClient } from "../../../client";
import mutationDocument from "./addOrUpdateOrderPaymentWithTokenValidation.graphql";
import type {
  InputAddOrUpdateOrderPaymentWithTokenValidationType,
  Mutations,
  MutationsAddOrUpdateOrderPaymentWithTokenValidationArgs,
  AddOrUpdateOrderPaymentWithTokenValidationResultType,
} from "@/core/api/graphql/types";

export async function addOrUpdateOrderPaymentWithTokenValidation(
  payload: InputAddOrUpdateOrderPaymentWithTokenValidationType,
): Promise<AddOrUpdateOrderPaymentWithTokenValidationResultType> {
  const result = await graphqlClient.mutate<
    Required<Pick<Mutations, "addOrUpdateOrderPaymentWithTokenValidation">>,
    MutationsAddOrUpdateOrderPaymentWithTokenValidationArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: payload,
    },
  });

  return {
    isSuccess: result.data?.addOrUpdateOrderPaymentWithTokenValidation?.isSuccess ?? false,
    errorMessage: result.data?.addOrUpdateOrderPaymentWithTokenValidation?.errorMessage || undefined,
    order: result.data?.addOrUpdateOrderPaymentWithTokenValidation?.order || undefined,
  };
}
